import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { contentApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'content-edit-category';

export const editContentCategory = ({
  id,
  name,
  pageId,
}: Pick<contentApiTypes.EditCategoryParams, 'id' | 'name' | 'pageId'>) => {
  return axios.patch(
    `/content/categories/${id}`,
    { name },
    { params: { pageId } }
  ) as Promise<contentApiTypes.EditCategoryResponse>;
};

type EditContentCategoryOptions = {
  config?: MutationConfig<typeof editContentCategory>;
};

export const useEditContentCategory = ({ config = {} }: EditContentCategoryOptions = {}) => {
  const { onSuccess, onMutate, onError, ...restConfig } = config;

  return useMutation({
    ...restConfig,
    mutationFn: editContentCategory,
    onMutate: (variables) => {
      toasts.loadingToast.loading(TOAST_ID, 'Сохранение...');
      return onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      toasts.loadingToast.success(TOAST_ID, 'Категория обновлена');
      const pageId = data.category.page._id;
      queryClient.invalidateQueries(['content-categories', pageId]);
      queryClient.invalidateQueries(['content-materials', pageId]);
      onSuccess?.(data, variables, context);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      onError?.(error, variables, context);
    },
  });
};
